import type { ILocale } from '~/interfaces/states/locale.state';

export const useLocale = () => {
  return useState<ILocale>('locale', () => ({
    debug: false,
    messagesMap: new CaseInsensitiveMap(),
    locale: '',
    localeOptions: [{}],
  }));
};
